import React from "react";

const BYU_NAVY = "#002E5D";
const BYU_BLUE = "#0057B7";
const BYU_BG = "#F5F7FA";

const projects = [
    {
        img: "/Lucid.jpeg",
        title: "Lucid Software Capstone",
        description: "With a team of 4, developed a customer requested Lucidspark card integration. This project mimicked a real-world software engineering environment and included weekly meetings with Lucid.",
        link: "https://cs.byu.edu/education/undergraduate/programs/capstone/",
        linkText: "About BYU Capstone",
    },
    {
        img: "https://seeklogo.com/images/U/utah-jazz-1996-2004-logo-E496606DE0-seeklogo.com.png",
        title: "Utah Jazz Stats Dashboard and AI Chatbot",
        description: "Python script that scrapes Utah Jazz stats, JWT token authentication, Supabase database, and React frontend with Node.js backend.",
        link: "https://github.com/adamlg1/Jazz-Dashboard",
        linkText: "View Code",
    },
    {
        img: "/BYU.png",
        title: "Decommissioning BYU's Cisco Phone System",
        description: "My team decomissioned BYU's Cisco phone system. This involved inventorying, locating, and returning over 400 outdated devices to surplus.",
        link: "https://phones.byu.edu/byu-campus-phone-system-transition",
        linkText: "About BYU's Phone Transition",
    },
    {
        img: "/Rentagades.png",
        title: "Rentagades",
        description: "Figma prototype for a housing search application. Completed in a team of 5. We followed many principles found in Norman's The Design of Everyday things while iterating through this project.",
        link: "https://www.amazon.com/Design-Everyday-Things-Revised-Expanded/dp/0465050654",
        linkText: "See Norman's Book",
    },
    {
        img: "/message_icon.png",
        title: "Real-time Chat Web App",
        description: "My first full-stack website, built using React, Node.js, MongoDB, JavaScript, CSS, HTML, and websockets.",
        link: "https://github.com/adamlg1/startup",
        linkText: "View Code",
    },
    {
        img: "/basketball.jpg",
        title: "2025 NCAA Tournament Predictor",
        description: "Experimented with different machine learning and deep learning models to predict the point differential of the 2025 NCAA tournament. In the end, LSTM was the best performing model.",
        link: process.env.PUBLIC_URL + "/ncaa_results.png",
        linkText: "View Results",
    },
    {
        img: "/pizza.jpg",
        title: "Pizza DevOps",
        description: "A website that was given to us to learn DevOps. This included me writing code for logging, a CI/CD pipline, a production and development environment, load testing, learning scalability, and much more!",
        link: "https://github.com/adamlg1/jwt-pizza",
        linkText: "View Code",
    },
    {
        img: "/heart.jpg",
        title: "Heart Disease Predictor",
        description: "Built as part of a group project in my introductory Machine Learning class. After trying different models, we found the random forest classifier to be the most effective model at predicting heart disease. The most important features in predicting disease were sysBP, BMI, and age.",
        link: process.env.PUBLIC_URL + "/270_results.png",
        linkText: "View Results",
    },
    {
        img: "/screamtransfer.png",
        title: "Style Transfer",
        description: "Implemented the style transfer algorithm proposed by Gatys et. al.(2016). Above you will see the scream painting's style transferred onto Koli, Finland.",
        link: process.env.PUBLIC_URL + "/styleresults.png",
        linkText: "View Results",
    },
];

const Projects = () => (
    <section className="py-5" style={{ background: BYU_BG }}>
        <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 style={{ fontWeight: 700, fontSize: "2.2rem", color: BYU_NAVY, marginBottom: 0 }}>
                    Featured Projects
                </h2>
                <a
                    href="https://github.com/adamlg1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-dark d-flex align-items-center"
                    style={{
                        borderColor: BYU_NAVY,
                        color: BYU_NAVY,
                        borderRadius: 10,
                        fontWeight: 600,
                        gap: 8,
                        background: "#fff"
                    }}
                    aria-label="View my GitHub"
                >
                    <img src={process.env.PUBLIC_URL + "/github-mark.png"} alt="GitHub Logo" style={{ width: 28, height: 28 }} />
                    <span className="d-none d-md-inline">GitHub</span>
                </a>
            </div>
            <div className="row">
                {projects.map((project, idx) => (
                    <div className="col-md-4 mb-4" key={idx}>
                        <div className="card h-100 shadow-sm border-0" style={{ borderRadius: 16 }}>
                            <div className="card-body text-center">
                                <div
                                    className="d-flex align-items-center justify-content-center mb-3"
                                    style={{
                                        width: 64,
                                        height: 64,
                                        borderRadius: 16,
                                        background: BYU_BLUE,
                                        margin: "0 auto",
                                        overflow: "hidden",
                                    }}
                                >
                                    {project.img && (
                                        <img
                                            src={project.img.startsWith("http") ? project.img : process.env.PUBLIC_URL + project.img}
                                            alt={project.title + " logo"}
                                            style={{ width: 40, height: 40, objectFit: "contain" }}
                                        />
                                    )}
                                </div>
                                <h5 className="card-title" style={{ fontWeight: 700, color: BYU_NAVY }}>{project.title}</h5>
                                <p className="card-text" style={{ color: BYU_NAVY }}>{project.description}</p>
                                {project.linkText && (
                                    <a
                                        href={project.link}
                                        className="btn btn-outline-primary"
                                        style={{
                                            borderColor: BYU_NAVY,
                                            color: BYU_NAVY,
                                            borderRadius: 10,
                                            fontWeight: 600,
                                        }}
                                    >
                                        {project.linkText} <i className="bi bi-arrow-right"></i>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Projects;